module.exports = __webpack_public_path__ + "img/img10.9c567376.svg";